<main class="center-main">
  <section class="container-fluid">
    <form [formGroup]="resetForm" autocomplete="off" novalidate (ngSubmit)="onSubmit()">
      <div class="login">
        <div class="text-center mb-3">
          <img src="../../../../../assets/images/logo-login.png" class="logo-login" alt="">
        </div>
        <hr />

        <!-- EMAIL -->

        <div class="info-box mb-3 rounded shadow-sm" *ngIf="!showCodeAndPassword">
          <p class="mb-0 small text-muted">
            Ingresa tu correo electrónico y te enviaremos un código de verificación con validez de <strong>10
              minutos</strong>.
            Luego podrás establecer una nueva contraseña de forma segura.
          </p>
        </div>


        <div class="mb-3" *ngIf="!showCodeAndPassword">
          <label for="email">Correo electrónico</label>
          <input type="email" class="form-control" formControlName="email"
            [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
          <div class="text-danger small" *ngIf="submitted && f.email.errors">
            <div *ngIf="f.email.errors['required']">El correo es obligatorio.</div>
            <div *ngIf="f.email.errors['email']">Correo inválido.</div>
          </div>
        </div>

        <!-- BOTÓN ENVIAR CÓDIGO -->
        <div class="mb-3" *ngIf="!showCodeAndPassword">
          <button class="btn btn-primary w-100" type="button" (click)="sendCode()">Enviar código</button>
        </div>

        <div class="mb-3 text-center" *ngIf="!showCodeAndPassword">
          <button type="button" class="btn btn-link" routerLink="/login">Ir al login</button>
        </div>

        <!-- CÓDIGO Y CONTRASEÑAS -->
        <div *ngIf="showCodeAndPassword">

          <!-- CÓDIGO -->
          <div class="mb-3">
            <label for="code">Código de verificación</label>
            <input type="text" class="form-control" formControlName="code"
              [ngClass]="{ 'is-invalid': (submitted || f.code.touched || f.code.dirty) && f.code.errors }" />
            <div class="text-danger small" *ngIf="submitted && f.code.errors">
              <div *ngIf="f.code.errors['required']">El código es obligatorio.</div>
              <div *ngIf="f.code.errors['minlength']">Debe tener al menos 6 caracteres.</div>
            </div>
          </div>

          <!-- CONTRASEÑA -->
          <div class="mb-3">
            <label for="password">Nueva contraseña</label>
            <input type="password" class="form-control" formControlName="password"
              [ngClass]="{ 'is-invalid': (submitted || f.code.touched || f.code.dirty) && f.code.errors }" />
            <div class="text-danger small" *ngIf="submitted && f.password.errors">
              <div *ngIf="f.password.errors['required']">La contraseña es obligatoria.</div>
              <div *ngIf="f.password.errors['minlength']">Mínimo 4 caracteres.</div>
            </div>
          </div>

          <!-- CONFIRMAR CONTRASEÑA -->
          <div class="mb-3">
            <label for="confirmPassword">Confirmar contraseña</label>
            <input type="password" class="form-control" formControlName="confirmPassword"
              [ngClass]="{ 'is-invalid': (submitted || f.code.touched || f.code.dirty) && f.code.errors }" />
            <div class="text-danger small" *ngIf="submitted && f.confirmPassword.errors">
              <div *ngIf="f.confirmPassword.errors['required']">Debes confirmar tu contraseña.</div>
            </div>

            <!-- COINCIDENCIA -->
            <div class="text-danger small" *ngIf="submitted && f.password.value !== f.confirmPassword.value">
              Las contraseñas no coinciden.
            </div>
          </div>

          <!-- BOTÓN CAMBIAR CONTRASEÑA -->
          <div class="mb-3">
            <button class="btn btn-success w-100" type="submit">Cambiar contraseña</button>
          </div>
          <div class="mb-3 text-center">
            <button type="button" class="btn btn-link" routerLink="/login">Ir al login</button>
          </div>
        </div>
      </div>
    </form>
  </section>
</main>
